module.exports = __webpack_public_path__ + "static/media/firefox.8433c877.svg";